package uz.ferro.shop.ui.table

data class RowItem(
    val key: String,
    val cells: List<CellItem>,
    val onItemClick: (() -> Unit)? = null
)
